import { initCoralComments } from '../comments';

initCoralComments();
